import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommerceService } from 'app/services/commerce.service';
import { DETAILS_INPUT } from './edit-availed-product-details';
import * as moment from 'moment';

@Component({
  selector: 'edit-availed-product-details',
  standalone: false,
  templateUrl: './edit-availed-product-details.component.html',
  styleUrl: './edit-availed-product-details.component.scss'
})
export class EditAvailedProductDetailsComponent implements OnInit {

  @Output() isDetailsInvalid = new EventEmitter<boolean>();

  constructor(
      private commerceService: CommerceService
  ){

  }

  public selectedRestart: string = 'manual';
  public dataInput: any;
  public selectedStatus: string = '';
  public remarks: string = '';
  public detailsDto = {
    reason: '',
    remarks: '',
    specificReason: '',
    selectedDate: '',
    type: ''
  };
  public minDate = new Date();

  ngOnInit(): void {
    if(this.commerceService.availedProductStatus){
      this.dataInput = DETAILS_INPUT[this.commerceService.availedProductStatus];
      this.selectedStatus = this.commerceService.availedProductStatus;
    }
    if(this.commerceService.availedProductDetails){
      this.detailsDto = this.commerceService.availedProductDetails;
    }
  }

  formChanged() {
    this.commerceService.availedProductDetails = this.detailsDto;
    if(this.detailsDto.reason === 'Others'){
      this.isDetailsInvalid.emit(!this.selectedRestart || !this.detailsDto.selectedDate || !this.detailsDto.reason || !this.detailsDto.specificReason);
    } else {
      this.isDetailsInvalid.emit(!this.selectedRestart || !this.detailsDto.selectedDate || !this.detailsDto.reason);
    }
  }
}
